module.exports = __webpack_public_path__ + "images/skewness-02-desktop.png";